export default "<div class=\"snackbar\">\r\n\r\n  <p class=\"snackbar-text\">\r\n    {{ data.message }}\r\n  </p>\r\n\r\n</div>"